import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { Globals } from '../../../globals';
import { ConfigurationServices } from '../../configuration/services';


@Component({
  selector: 'page-complements-partial-selected',
  templateUrl: 'complements-partial-selected.html',
})
export class ComplementsPartialSelectedPage {
  //datatable
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public configurationServices: ConfigurationServices,
    public translate: TranslateService,) {

  }

  removeSelected(index: number) {
    if (index >= 0) {
      this.configurationServices.complements_groups_selected.splice(index, 1);
      this.configurationServices.complements_groups_selected = [...this.configurationServices.complements_groups_selected];
    }
  }

  reorderSections(indexes) {
    let element = this.configurationServices.complements_groups_selected[indexes.from];
    this.configurationServices.complements_groups_selected.splice(indexes.from, 1);
    this.configurationServices.complements_groups_selected.splice(indexes.to, 0, element);
  }

  activePos(index: number) {
    if (index >= 0) {
      this.configurationServices.complements_groups_selected[index].pos_active = !this.configurationServices.complements_groups_selected[index].pos_active;
    }
  }

  activeTK(index: number) {
    if (index >= 0) {
      this.configurationServices.complements_groups_selected[index].tk_active = !this.configurationServices.complements_groups_selected[index].tk_active;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/complements/complements-partial-selected/complements-partial-selected.ts